import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.focusOnInput()
  }

  focusOnInput(){
    if (this.element.dataset.isFocus === 'true' && this.element.getElementsByTagName('textarea')[0]){
      this.element.getElementsByTagName('textarea')[0].focus()
    }
  }
}
